import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, exhaustMap, map } from 'rxjs/operators';
import { App } from '@store/actions/app.actions';
import { PhotoGalleryActions } from '@store/actions/photo-gallery.actions';
import { PhotoGalleryService } from '@modules/shared/services/photo-gallery.service';

@Injectable()
export class PhotoGalleryEffects {
  private readonly actions$ = inject(Actions);
  private readonly photoGalleryService = inject(PhotoGalleryService);


  getPhotoGalleries$ = createEffect(() => this.actions$.pipe(
    ofType(PhotoGalleryActions.GET_PHOTO_GALLERIES, App.INITIALIZE),
      exhaustMap(() => this.photoGalleryService.getAll()
        .pipe(
          map(payload => ({type: PhotoGalleryActions.GET_PHOTO_GALLERIES_SUCCESS, payload})),
          catchError(error => of(({type: PhotoGalleryActions.GET_PHOTO_GALLERIES_FAILED, error}))),
        )),
    ),
  );

  updatePhotoGallery$ = createEffect(() => this.actions$.pipe(
      ofType(PhotoGalleryActions.UPDATE_PHOTO_GALLERY),
    exhaustMap((payload: any) => {
      return this.photoGalleryService.update(payload)
        .pipe(
          map(payload => ({type: PhotoGalleryActions.UPDATE_PHOTO_GALLERY_SUCCESS, payload})),
          catchError(error => of(({type: PhotoGalleryActions.UPDATE_PHOTO_GALLERY_FAILED, error}))),
        );
    }),
    ),
  );

  createPhotoGallery$ = createEffect(() => this.actions$.pipe(
      ofType(PhotoGalleryActions.CREATE_PHOTO_GALLERY),
      exhaustMap((payload) => this.photoGalleryService.create(payload)
        .pipe(
          map(payload => ({type: PhotoGalleryActions.CREATE_PHOTO_GALLERY_SUCCESS, payload})),
          catchError(error => of(({type: PhotoGalleryActions.CREATE_PHOTO_GALLERY_FAILED, error}))),
        )),
    ),
  );

  deletePhotoGallery$ = createEffect(() => this.actions$.pipe(
      ofType(PhotoGalleryActions.DELETE_PHOTO_GALLERY),
      exhaustMap(({payload}) => this.photoGalleryService.delete(payload)
        .pipe(
          map(payload => ({type: PhotoGalleryActions.DELETE_PHOTO_GALLERY, payload})),
          catchError(error => of(({type: PhotoGalleryActions.DELETE_PHOTO_GALLERY_FAILED, error}))),
        )),
    ),
  );
}
